const types = require('../../constants/actionTypes');

const fetchSucceeded = ({ funds }) => ({
    type: types.FUNDS_FETCH_SUCCEEDED,
    payload: { funds },
});

module.exports = fetchSucceeded;
